module.exports = __webpack_public_path__ + "static/img/hui01.2d468d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hui01.png
// module id = 1144
// module chunks = 1